<div class="ap-navigation-demo-wrapper">
  <gstar-navigation
    #nav
    [selectedIndex]="selectedIndex()"
    [selectedSubIndex]="selectedSubIndex()"
    [selectedNestedIndex]="selectedNestedIndex()"
    [navList]="navList()"
    width="280px"
    [hasFooter]="hasFooter"
    [solid]="solid"
    [collapsed]="collapsed"
    (clickItem)="redirect($event)">
    <gstar-investment-jurisdiction-nav-combobox
      class="px-2"
      [value]="selectedCountry()"
      (selectInvestmentJurisdiction)="selectCountryHandler($event)" />
    @if (isCountryDisabled) {
      <div class="ap-field-validation-error">
        {{ 'countryInformation.countryErrorMessage' | translate }}
      </div>
    }
  </gstar-navigation>
</div>
